export enum Domain {
  CHECKOUT = 'checkout',
  EXPERIENCE = 'experience',
  MEMBERS_AREA = 'members-area',
  SAMPLE_TRIP = 'sample-trip',
  STAFF_AREA = 'staff-area',
  TRIP = 'trip',
}
